import { render } from "./ProfiteiaLogoText.vue?vue&type=template&id=110cfb32"
import script from "./ProfiteiaLogoText.vue?vue&type=script&lang=js"
export * from "./ProfiteiaLogoText.vue?vue&type=script&lang=js"

import "./ProfiteiaLogoText.vue?vue&type=style&index=0&id=110cfb32&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__